module.exports = __webpack_public_path__ + "static/img/T251127.a6d1da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T251127.png
// module id = hHo1
// module chunks = 5